const baseUrl = "/data-hub";

export default {
  baseUrl,
  ORCHESTRATION_CONFIGURATION_HUB_PROJECTS: `${baseUrl}/orchestration/configuration-hub/projects`,
  ORCHESTRATION_CONFIGURATION_HUB: `${baseUrl}/orchestration/configuration-hub`,
  ORCHESTRATION_CONNECTIONS: `${baseUrl}/orchestration/connections`,
  ORCHESTRATION_DATA_MONITORS: `${baseUrl}/orchestration/data-monitors`,
  ORCHESTRATION_MONITORING: `${baseUrl}/operations/monitoring/orchestration`,
  DATA_MAPPING_MONITORING: `${baseUrl}/operations/monitoring/data-mapping`,
  ORCHESTRATION_DATA_MAPPING: `${baseUrl}/orchestration/data-mapping`,
  ORCHESTRATION_DATA_CATALOG: `${baseUrl}/orchestration/data-catalog`,
  ORCHESTRATION_DATA_TEST: `${baseUrl}/orchestration/data-test`,
  TRANSFORMATION_RECODING: `${baseUrl}/transformation/recoding`,
  TRANSFORMATION_RECODING_VALUE_MAPPING: `${baseUrl}/transformation/recoding/value-mapping`,
  TRANSFORMATION_RECODING_RULE_SET: `${baseUrl}/transformation/recoding/rule-set`,
  TRANSFORMATION_VALUE_LISTS: `${baseUrl}/transformation/value-lists`,
  TRANSFORMATION_MANAGED_TABLES: `${baseUrl}/transformation/managed-tables`,
  OPERATIONS_MONITORING_DATA_PROCESSING: `${baseUrl}/operations/monitoring/data-processing`,
  OPERATIONS_MONITORING_JOB_PROCESSING: `${baseUrl}/operations/monitoring/job-processing`,
  DATA_MODEL_ERD: `${baseUrl}/data-model/erd`,
  DATA_MODEL_LINEAGE_GRAPH: `${baseUrl}/data-model/lineage-graph`,
  DATA_MODEL_CATALOG_OVERVIEW: `${baseUrl}/data-model/catalog-overview`,
  ACTIVITY_STREAM: `${baseUrl}/activity-stream`,
};
